import { IconCloudUpload } from '@tabler/icons-react';
import { ElementType } from 'react';

import { ZorroIcon } from '../../Icon';
import { ZorroStack } from '../../Stack';
import { ZorroText } from '../../Text';

type Props = {
  icon?: ElementType;
  title?: string;
  subtitle?: string;
};

export const EmptyDropzone = ({
  icon = IconCloudUpload,
  title = 'Nothing here yet',
  subtitle,
}: Props) => {
  return (
    <ZorroStack align="center" justify="center" gap="xxs" w="100%" h="100%">
      <ZorroIcon
        color="var(--color-icon-stroke-tag-indigo)"
        stroke="var(--stroke-1-5)"
        icon={icon}
        size={40}
      />
      <ZorroText size="sm" fw={600}>
        {title}
      </ZorroText>
      {subtitle && (
        <ZorroText size="xs" c="var(--color-text-default-secondary)" fw={400}>
          {subtitle}
        </ZorroText>
      )}
    </ZorroStack>
  );
};
